<template>
  <div class="absolute" :class="props.root">
    <div
      :class="props.wrapper"
      class="rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 cursor-pointer flex justify-center items-center"
    >
      <UIcon v-if="props.iconName" :name="props.iconName" :class="props.icon" />
      <NuxtImg
        v-if="props.imgSrc"
        :src="props.imgSrc"
        :class="props.img"
        class="object-contain"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  root: string;
  wrapper: string;
  iconName?: string;
  icon?: string;
  imgSrc?: string;
  img?: string;
}>();
</script>

<style></style>
